<script lang="ts">
  import { updated } from '$app/state';
  import { ConfirmDialog } from '$lib/ui';
  import { t } from '$lib/i18n';
  import { UiKeys } from '@voicedojo/backend-types';

  let { inTake }: { inTake: boolean } = $props();

  // SvelteKit stops polling once it sees a new version, so one flag covers "this version".
  let dismissed = $state(false);
</script>

{#if updated.current && !inTake && !dismissed}
  <ConfirmDialog
    title={t(UiKeys.NewVersion.Title)}
    body={t(UiKeys.NewVersion.Body)}
    confirmLabel={t(UiKeys.NewVersion.Refresh)}
    confirmVariant="primary"
    cancelLabel={t(UiKeys.NewVersion.Later)}
    testid="new-version"
    onConfirm={() => location.reload()}
    onCancel={() => (dismissed = true)}
  />
{/if}
